import { inject, Injectable } from '@angular/core';
import { NavigationEnd, NavigationError, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ROOT } from '@shared/constants/routing-paths.constants';
import { CHUNK_LOAD_ERRORS } from '@shared/constants/common.constants';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private router = inject(Router);
  private location = inject(Location);
  private history: string[] = [];

  init() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
      if (event instanceof NavigationError) {
        const message = event?.error?.message;
        if (message?.includes(CHUNK_LOAD_ERRORS)) {
          console.error('Chunk load error:', event.error);
          window.location.reload();
        }
      }
    });
  }

  back() {
    if (this.history?.length) {
      this.history.pop();
    }

    if (!!this.history && this.history?.length > 0) {
      this.location.back();
    } else {
      void this.router.navigateByUrl(ROOT);
    }
  }
}
